import * as dotenv from 'dotenv';

dotenv.config({ path: `./environments/.env.${process.env.NODE_ENV || 'development'}` });




export const base_api_url = process.env.REACT_APP_BASE_API_URL;



